<style scoped lang="scss" type="text/scss">
    .player-application-popup {
        .info-panel {
            margin-top: .5rem;

            &:first-of-type {
                margin-top: 0;
            }
        }
    }
</style>

<template>
    <el-dialog title="正在提交参赛申请" class="player-application-popup"
               :visible.sync="visibleSync"
               :close-on-click-modal="false"
               @closed="reset"
               width="70%">
        <el-form ref="form" :model="playerApplicationInfo" :rules="rules" label-width="110px">

            <el-form-item label="申请赛事" prop="competition_name">
                <el-input v-model="playerApplicationInfo.competition_name" disabled></el-input>
            </el-form-item>

            <el-form-item label="指定学生队长" prop="student_leader_id">
                <user-search-box v-model="playerApplicationInfo.student_leader_id"></user-search-box>
            </el-form-item>

            <terms-text-container></terms-text-container>

            <el-form-item style="margin-bottom: 0;">
                <el-button type="primary" plain @click="create()" :loading="requesting">确认</el-button>
                <el-button @click="cancel()">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import UserSearchBox from '../../../../sub-components/user-search-box/index';
    import InfoPanel from '../../../../../components/info-panel/index';
    import TermsTextContainer from './terms-text';

    export default {
        name: '',
        components: {
            UserSearchBox,
            InfoPanel,
            TermsTextContainer
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            competition: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        watch: {
            visible (visible) {
                this.visibleSync = visible;
            },
            visibleSync (visibleSync) {
                this.$emit('update:visible', visibleSync);
            },
            competition: {
                immediate: true,
                handler (competition) {
                    if (competition !== null) this.playerApplicationInfo.competition_name = competition.name;
                }
            }
        },
        data () {
            return {
                visibleSync: null,
                playerApplicationInfo: {},
                requesting: false,
                rules: {
                    competition_name: [
                        {required: true, message: '申请赛事不能为空', trigger: 'blur'}
                    ],
                    student_leader_id: [
                        {type: 'number', required: true, message: '请选择该届参赛队学生队长', trigger: 'blur'}
                    ]
                }
            };
        },
        computed: {
            currentManagedTeamId () {
                return this.$store.state.team.currentManagedTeamId;
            }
        },
        methods: {
            create () {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    const playerApplicationInfo = this.playerApplicationInfo;
                    this.$normalRequest('competition/applyPlayer', {
                        competition_id: this.competition.id,
                        team_id: this.currentManagedTeamId,
                        student_leader_id: playerApplicationInfo.student_leader_id
                    }, '申请提交成功', true, this, 'requesting').then(_ => {
                        this.afterSuccess();
                    }).catch(_ => {
                        this.$refs.form.clearValidate();
                    });
                });
            },
            cancel () {
                this.reset();
            },
            afterSuccess () {
                this.$emit('need-reload');
                this.reset();
            },
            reset () {
                this.$refs.form.clearValidate();
                this.visibleSync = false;
                this.playerApplicationInfo.student_leader_id = null;
            }
        }
    };
</script>
